import React, { useState } from "react";
import * as Styled from "./Tip.styled";
import { Typography } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import Button from "@mui/material/Button";
import CachedIcon from "@mui/icons-material/Cached";
import { TIPSYRECOMENDACIONESID } from "./TipsYRecomendaciones";
import { helpHttp } from "../../helper/helpHttp";
import { toast } from "react-toastify";

export const Tip = ({ title, video, image, onClick, id }) => {
  const [downloadingPdf, setDownloadingPdf] = useState(false);
  const { get } = helpHttp();

  const downloadPdf = () => {
    setDownloadingPdf(true);
    get(
      `categorias/getDetailCategoriaByIdDetail/${TIPSYRECOMENDACIONESID}/${id}`
    )
      .then((response) => {
        const pdfData = response.datos.url_pdf;
        if (!pdfData) {
          throw new Error("");
        }
        const pdfLink = document.createElement("a");
        pdfLink.href = pdfData;
        pdfLink.download = `${title}.pdf`;
        document.body.appendChild(pdfLink);
        pdfLink.click();
        document.body.removeChild(pdfLink);
      })
      .catch((error) => {
        toast.error("No se pudo descargar el PDF");
      })
      .finally(() => {
        setDownloadingPdf(false);
      });
  };

  const handleClick = () => {
    if (video?.trim()) {
      onClick(video);
    } else {
      downloadPdf();
    }
  };

  return (
    <Styled.Container onClick={handleClick}>
      <Styled.Cover img={image}>
        <Styled.CoverImg />

        {video?.trim() ? (
          <Styled.PlayButton>
            <PlayArrowIcon fontSize={"large"} />
          </Styled.PlayButton>
        ) : (
          <Button
            disabled={downloadingPdf}
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => downloadPdf(e.id, e.titulo)}
            sx={{ marginTop: "15px", width: "max-content" }}
            endIcon={
              downloadingPdf ? (
                <CachedIcon className="downloadingPdf" />
              ) : (
                <PictureAsPdfOutlinedIcon />
              )
            }
          >
            Descargar
          </Button>
        )}
      </Styled.Cover>
      <Typography
        component={"h3"}
        variant="title"
        fontSize={22}
        sx={{ paddingLeft: "10px", paddingTop: "10px" }}
      >
        {title}
      </Typography>
    </Styled.Container>
  );
};
